// --------------------------------------------------------------
// Created On: 2025-05-20
// Author: Hannah Vaughan
//
// Last Modified: 2025-05-21
// Modified By: Hannah Vaughan
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

export const INITIAL_BREADCRUMBS: BreadcrumbPage[] = [
  {
    title: "Asset Details",
    pageNumber: 1,
  },
];

export const NO_DATA_COLLECTION_BREADCRUMBS: BreadcrumbPage[] = [
  {
    title: "Asset Details",
    pageNumber: 1,
  },
  {
    title: "Product",
    pageNumber: 2,
  },
  {
    title: "Data",
    pageNumber: 3,
  },
];

export const DATA_COLLECTION_NO_SENSORS_BREADCRUMBS: BreadcrumbPage[] = [
  {
    title: "Asset Details",
    pageNumber: 1,
  },
  {
    title: "Product",
    pageNumber: 2,
  },
  {
    title: "Modbus",
    pageNumber: 3,
  },
  {
    title: "Data",
    pageNumber: 4,
  },
];

export const DATA_COLLECTION_BREADCRUMBS: BreadcrumbPage[] = [
  {
    title: "Asset Details",
    pageNumber: 1,
  },
  {
    title: "Product",
    pageNumber: 2,
  },
  {
    title: "Modbus",
    pageNumber: 3,
  },
  {
    title: "Analog",
    pageNumber: 4,
  },
  {
    title: "Digital",
    pageNumber: 5,
  },
  {
    title: "Data",
    pageNumber: 6,
  },
];

export const DATA_COLLECTION_NO_ANALOG_BREADCRUMBS: BreadcrumbPage[] = [
  {
    title: "Asset Details",
    pageNumber: 1,
  },
  {
    title: "Product",
    pageNumber: 2,
  },
  {
    title: "Modbus",
    pageNumber: 3,
  },
  {
    title: "Digital",
    pageNumber: 4,
  },
  {
    title: "Data",
    pageNumber: 5,
  },
];

export const DATA_COLLECTION_NO_DIGITAL_BREADCRUMBS: BreadcrumbPage[] = [
  {
    title: "Asset Details",
    pageNumber: 1,
  },
  {
    title: "Product",
    pageNumber: 2,
  },
  {
    title: "Modbus",
    pageNumber: 3,
  },
  {
    title: "Analog",
    pageNumber: 4,
  },
  {
    title: "Data",
    pageNumber: 5,
  },
];

interface BreadcrumbPage {
  title: string;
  pageNumber: number;
}
